<template>
  <v-content>
    <v-container
      fluid
      fill-height>
      <v-layout
        align-center
        justify-center>
        <v-flex
          xs12
          sm8
          md4>
          <v-card class="elevation-12">
            <v-toolbar
              class="primary"
              dark>
              <v-toolbar-title>Vanhoutte Control Panel</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-alert
                v-if="loginError"
                :value="true"
                type="error"
                outline>
                Verkeerde email of wachtwoord.
              </v-alert>
              <v-form
                ref="form"
                v-model="valid">
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  prepend-icon="person"
                  name="email"
                  label="E-mail"
                  type="email"
                  required
                  @keyup.enter="submit" />
                <v-text-field
                  id="password"
                  v-model="password"
                  :rules="passwordRules"
                  prepend-icon="lock"
                  name="password"
                  label="Wachtwoord"
                  type="password"
                  required
                  @keyup.enter="submit" />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                :disabled="!valid"
                class="secondary"
                @click="submit">
                Log In
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Login",
  data: () => ({
    valid: true,
    loginError: false,
    email: "",
    emailRules: [
      v => !!v || "E-mail moet ingevuld worden",
      v => /.+@.+/.test(v) || "Dit is geen geldig e-mailadres"
    ],
    password: "",
    passwordRules: [
      v => !!v || "Wachtwoord moet ingevuld worden"
    ]
  }),
  computed: {
    ...mapGetters({
      token: "user/getToken"
    })
  },
  methods: {
    ...mapActions({
      login: "user/login"
    }),
    submit() {
      if (this.$refs.form.validate()) {
        this.login({ email: this.email, password: this.password })
          .then(() => {
            this.loginError = false;
            this.$router.push("/category");
          })
          .catch(() => {
            this.loginError = true;
          });
      }
    }
  }
};
</script>
